import { plansPath, orderStatusPath, accountPath, faqPath, faqMembershipPath } from '@constants/paths';
// @ts-ignore
import AppSearchAPIConnector from '@elastic/search-ui-app-search-connector';

/* Types */
type ElasticSearchServiceType = {
  remote_service: { raw: string };
  remote_only_service: { raw: string };
};

type SearchConfigType = {
  searchKey: string;
  engineName: string;
  endpointBase: string;
};

export const searchConfig = (apiKeys: SearchConfigType) => {
  const connector = new AppSearchAPIConnector({ ...apiKeys });

  return {
    alwaysSearchOnInitialLoad: false,
    a11yNotificationMessages: {
      searchResults: ({ searchTerm }: { searchTerm: string }) => `Searching for "${searchTerm}".`,
    },
    searchQuery: {
      search_fields: {
        name: {},
        category_name: {},
        seo_name: {},
      },
    },
    autocompleteQuery: {
      results: {
        result_fields: {
          name: {
            raw: {},
          },
          seo_name: {
            raw: {},
          },
          category_name: {
            raw: {},
          },
          category_icon: {
            raw: {},
          },
          category_seo_name: {
            raw: {},
          },
          average_review: {
            raw: {},
          },
          description: {
            raw: {},
          },
          available_through_customer_site: {
            raw: {},
          },
          remote_service: {
            raw: {},
          },
          remote_only_service: {
            raw: {},
          },
          is_product: {
            raw: {},
          },
          image: {
            raw: {},
          },
        },
      },
    },
    apiConnector: connector,
  };
};

export const PROMO_DETAILS = [
  {
    id: 1,
    title: 'Become a member and save up to $100 on your next service!',
    text: '',
    link: plansPath(),
    paddedImage: false,
    image: '_nextassets_/images/HT-logo-SHP.png',
  },
];

export const DEFAULT_TEXTS = {
  EMPTY_STATE: {
    title: 'No results for',
    text: 'Make sure all words are spelled correctly. Otherwise, please try different keywords.',
  },
  PLACEHOLDER: {
    heroSearchText: 'I need help with...',
    topNavSearchText: 'Search for a service or product',
  },
};

export const getServiceType = (service: ElasticSearchServiceType) => {
  switch (true) {
    case service.remote_service.raw === 'false' && service.remote_only_service.raw === 'false':
      return 'In-Home';
    case service.remote_only_service.raw === 'true':
      return 'Online';
    case service.remote_service.raw === 'true':
      return 'In-Home/Online';
    default:
      return null;
  }
};

export const categories = [
  {
    id: { raw: 1 },
    category_icon: { raw: 'ht-computer' },
    category_name: { raw: 'Computer Support' },
    category_seo_name: { raw: 'computers' },
  },
  {
    id: { raw: 2 },
    category_icon: { raw: 'ht-mobile-phone' },
    category_name: { raw: 'Mobile & Tablets' },
    category_seo_name: { raw: 'mobile' },
  },
  {
    id: { raw: 3 },
    category_icon: { raw: 'ht-wifi' },
    category_name: { raw: 'WiFi & Network' },
    category_seo_name: { raw: 'networking' },
  },
  {
    id: { raw: 4 },
    category_icon: { raw: 'ht-smart-home' },
    category_name: { raw: 'Smart Home' },
    category_seo_name: { raw: 'smart-home' },
  },
  {
    id: { raw: 5 },
    category_icon: { raw: 'ht-speakers' },
    category_name: { raw: 'Audio & Video' },
    category_seo_name: { raw: 'television-and-audio' },
  },
  {
    id: { raw: 6 },
    category_icon: { raw: 'ht-tv-mounting' },
    category_name: { raw: 'TV Mounting' },
    category_seo_name: { raw: 'tv-mounting' },
  },
  {
    id: { raw: 7 },
    category_icon: { raw: 'cat-icon-home-security' },
    category_name: { raw: 'Home Security' },
    category_seo_name: { raw: 'home-security' },
  },
  {
    id: { raw: 8 },
    category_icon: { raw: 'home-office-outline' },
    category_name: { raw: 'Around the Home' },
    category_seo_name: { raw: 'around-the-home' },
  },
];

export const quickLinks = [
  { id: 1, name: 'Track my order', link: orderStatusPath() },
  { id: 2, name: 'Manage my account', link: accountPath() },
  { id: 3, name: 'FAQ', link: faqPath(), routeType: 'next' },
  { id: 4, name: 'Membership Cancellation', link: faqMembershipPath(), routeType: 'next' },
];

/* Only using this to match icons. Why all these cat things.. */
export type TSkuCategoryDetailsStatic = {
  id: number;
  name: string;
  icon: string;
  rank: number;
};
export const skuCategoryDetails: TSkuCategoryDetailsStatic[] = [
  { id: 1, name: 'computer', icon: 'computer-support-outline', rank: 1 },
  { id: 2, name: 'wifi', icon: 'wifi-network-outline', rank: 1 },
  { id: 3, name: 'mobile', icon: 'mobile-tablet-outline', rank: 1 },
  { id: 4, name: 'audioVideo', icon: 'audio-video-outline', rank: 1 },
  { id: 7, name: 'tvMounting', icon: 'tv-mounting-outline', rank: 1 },
  { id: 8, name: 'smartHome', icon: 'smart-home-outline', rank: 1 },
  { id: 27, name: 'virtualServices', icon: 'cat-icon-virtual', rank: 1 },
  { id: 40, name: 'homeSecurity', icon: 'cat-icon-home-security', rank: 1 },
  { id: 41, name: 'aroundTheHome', icon: 'home-office-outline', rank: 1 },
];
